// import { ResizableImage } from './ResizableImage';

// window.app.controller('bikPhotoCtrl', ['$scope', '$http', function ($scope, $http) {
//     $scope.isPhotoAcceptable = false;
//     $scope.shareImg = '';

//     $('.openFish').click(function () {
//         $('.blockHidden').slideDown({ duration: 500 });
//         $scope.scrollTo(".bik-photo-text")
//     });

//     $scope.goToStep = function (step) {
//         $('.photo-rate').attr('step', step);
//     }

//     $scope.goToStep('1')

//     $('#setInputPhoto, #setInputPhoto2, #setInputPhoto3').on("click", function () {
//         $('#inputPhoto').click();
//     })

//     $('#inputPhoto').on("change", function (e) {
//         var img = document.createElement("img");
//         let reader = new FileReader();
//         reader.onload = function (event) {
//             img.src = event.target.result;

//             img.onload = function () {
//                 var width, height, dataurl;
//                 var canvas = document.createElement("canvas");
//                 var MAX_WIDTH = 514;
//                 var MAX_HEIGHT = 268;
//                 var MIN_HEIGHT = 200;
//                 width = img.width;
//                 height = img.height;

//                 let resizableImg = new ResizableImage(width, height, MAX_WIDTH, MAX_HEIGHT, MIN_HEIGHT);
//                 let imgSizes = resizableImg.getImageSize();
//                 width = imgSizes.width;
//                 height = imgSizes.height;

//                 // let orientation;
//                 // EXIF.getData(img, function () {
//                 //     orientation = EXIF.getTag(this, "Orientation");
//                 // });

//                 canvas.width = MAX_WIDTH;
//                 canvas.height = MAX_HEIGHT;
//                 var ctx = canvas.getContext("2d");

//                 // transform context before drawing image
//                 // if (orientation) {
//                 //     switch (orientation) {
//                 //         case 2: ctx.transform(-1, 0, 0, 1, width, 0); break;
//                 //         case 3: ctx.transform(-1, 0, 0, -1, width, height); break;
//                 //         case 4: ctx.transform(1, 0, 0, -1, 0, height); break;
//                 //         case 5: ctx.transform(0, 1, 1, 0, 0, 0); break;
//                 //         case 6: ctx.transform(0, 1, -1, 0, height, 0); break;
//                 //         case 7: ctx.transform(0, -1, -1, 0, height, width); break;
//                 //         case 8: ctx.transform(0, -1, 1, 0, 0, width); break;
//                 //         default: break;
//                 //     }
//                 // }
 
//                 ctx.drawImage(img, (canvas.width / 2 - width / 2), (canvas.height / 2 - height / 2), width, height);

//                 dataurl = canvas.toDataURL("image/png");
//                 $('.uploaded-photo').attr('src', dataurl);
//                 $scope.shareImg = $scope.makeblob(dataurl);
//             };
//             $scope.goToStep('2')
//             $scope.getPhotoInfo(event.target.result)
//         }
//         reader.readAsDataURL(e.target.files[0]);

//     })

//     $scope.rotateShareImg = () => {
//         let width = $(".uploaded-photo").width();
//         $(".photo-ctn").height(width);
//         $(".uploaded-photo").css("transform", "rotate(90deg)");
//     }

//     $scope.getPhotoInfo = function (src) {
//         // $('#analize').on("click", function() {
//         // Replace <Subscription Key> with your valid subscription key.
//         var subscriptionKey = "002521823df84dffb85ad77d1ceae1f7";

//         var uriBase =
//             "https://westeurope.api.cognitive.microsoft.com/face/v1.0/detect";


//         // Request parameters.
//         var params = {
//             "returnFaceId": "true",
//             "returnFaceLandmarks": "false",
//             "returnFaceAttributes":
//                 "age,gender,headPose,smile,facialHair,glasses,emotion," +
//                 "hair,makeup,occlusion,accessories,blur,exposure,noise"
//         };

//         // Display the image.
//         // var sourceImageUrl = document.getElementById("inputImage").value;
//         // document.querySelector("#sourceImage").src = sourceImageUrl;
//         var sourceImageUrl = $scope.makeblob(src);
//         // $scope.shareImg = sourceImageUrl;
//         // Perform the REST API call.
//         $.ajax({
//             url: uriBase + "?" + $.param(params),

//             // Request headers.
//             beforeSend: function (xhrObj) {
//                 xhrObj.setRequestHeader("Content-Type", "application/octet-stream");
//                 xhrObj.setRequestHeader("Ocp-Apim-Subscription-Key", subscriptionKey);
//                 xhrObj.setRequestHeader("charset", 'utf-8');
//             },
//             processData: false,
//             contentType: 'application/octet-stream',

//             type: "POST",

//             // Request body.
//             data: sourceImageUrl,
//         })

//             .done(function (data) {
//                 $scope.showButton();
//                 $scope.countPhotoActivity(1, 0);
//                 if (data && data.length === 1) {
//                     $scope.isPhotoAcceptable = true;
//                     let answer = '';
//                     let actualMatrix = [];
//                     let respArray = [];
//                     let age = data[0].faceAttributes.age;
//                     let gender = data[0].faceAttributes.gender;
//                     let facialHair = data[0].faceAttributes.facialHair;
//                     let emotion = data[0].faceAttributes.emotion;
//                     let accessories = data[0].faceAttributes.accessories;
//                     let smile = data[0].faceAttributes.smile;
//                     let glasses = data[0].faceAttributes.glasses;
//                     let makeup = data[0].faceAttributes.makeup;
//                     let faceHairPart = '';

//                     let priorityEmotion = Object.keys(emotion).reduce(function (a, b) {
//                         return emotion[a] > emotion[b] ? a : b;
//                     });


//                     let isHeadwear = accessories.some(function (i) {
//                         return i.type === 'headwear';
//                     });

//                     smile < 0.8 ? smile = 17 : smile = 18

//                     $('.personal-info').fadeIn()

//                     if (age < 18) {
//                         $('.ocena').fadeOut()
//                         $('#happiness').fadeOut()
//                         $('#conclusion').fadeOut()
//                     } else {
//                         $('#happiness').fadeIn()
//                         $('#conclusion').fadeIn()
//                         $('.ocena').fadeIn()
//                     }

//                     switch (glasses) {
//                         case 'NoGlasses':
//                             glasses = 19;
//                             break;
//                         case 'ReadingGlasses':
//                             glasses = 20;
//                             break;
//                         case 'SwimmingGoggles':
//                             glasses = 19;
//                             break;
//                         case 'sunglasses':
//                             glasses = 22;
//                             break;
//                     }

//                     switch (priorityEmotion) {
//                         case 'anger':
//                             priorityEmotion = 8;
//                             break;
//                         case 'contempt':
//                             priorityEmotion = 9;
//                             break;
//                         case 'disgust':
//                             priorityEmotion = 10;
//                             break;
//                         case 'fear':
//                             priorityEmotion = 11;
//                             break;
//                         case 'happiness':
//                             priorityEmotion = 12;
//                             break;
//                         case 'neutral':
//                             priorityEmotion = 13;
//                             break;
//                         case 'sadness':
//                             priorityEmotion = 14;
//                             break;
//                         case 'surprise':
//                             priorityEmotion = 15;
//                             break;
//                     }

//                     let matrixMen = [
//                         [1, 0, 0, 0, 0],
//                         [2, 5, 8, 0, 0],
//                         [2, 5, 9, 0, 0],
//                         [2, 5, 10, 0, 0],
//                         [2, 5, 11, 0, 0],
//                         [2, 5, 12, 18, 20],
//                         [2, 5, 12, 18, 22],
//                         [2, 5, 12, 18, 19],
//                         [2, 5, 12, 17, 20],
//                         [2, 5, 12, 17, 22],
//                         [2, 5, 12, 17, 19],
//                         [2, 5, 13, 0, 20],
//                         [2, 5, 13, 0, 22],
//                         [2, 5, 13, 0, 19],
//                         [2, 5, 14, 0, 20],
//                         [2, 5, 14, 0, 19],
//                         [2, 5, 14, 0, 22],
//                         [2, 5, 15, 0, 19],
//                         [2, 5, 15, 0, 20],
//                         [2, 5, 15, 0, 22],

//                         [2, 6, 8, 0, 0],
//                         [2, 6, 9, 0, 0],
//                         [2, 6, 10, 0, 0],
//                         [2, 6, 11, 0, 0],
//                         [2, 6, 12, 18, 20],
//                         [2, 6, 12, 18, 22],
//                         [2, 6, 12, 18, 19],
//                         [2, 6, 12, 0, 20],
//                         [2, 6, 12, 0, 22],
//                         [2, 6, 12, 0, 19],
//                         [2, 6, 13, 0, 20],
//                         [2, 6, 13, 0, 22],
//                         [2, 6, 13, 0, 19],
//                         [2, 6, 14, 0, 20],
//                         [2, 6, 14, 0, 19],
//                         [2, 6, 14, 0, 22],
//                         [2, 6, 15, 0, 19],
//                         [2, 6, 15, 0, 20],
//                         [2, 6, 15, 0, 22],
//                         [3, 0, 0, 0, 0]
//                     ]
//                     let matrixWoman = [
//                         [1, 0, 0, 0],
//                         [0.2, 8, 0, 0],
//                         [0.2, 9, 0, 0],
//                         [0.2, 10, 0, 0],
//                         [0.2, 11, 0, 0],
//                         [0.2, 12, 18, 20],
//                         [0.2, 12, 18, 22],
//                         [0.2, 12, 18, 19],
//                         [0.2, 12, 17, 20],
//                         [0.2, 12, 17, 22],
//                         [0.2, 12, 17, 19],
//                         [0.2, 13, 0, 20],
//                         [0.2, 13, 0, 22],
//                         [0.2, 13, 0, 19],
//                         [0.2, 14, 0, 20],
//                         [0.2, 14, 0, 19],
//                         [0.2, 14, 0, 22],
//                         [0.2, 15, 0, 19],
//                         [0.2, 15, 0, 20],
//                         [0.2, 15, 0, 22],

//                         [0.3, 8, 0, 0],
//                         [0.3, 9, 0, 0],
//                         [0.3, 10, 0, 0],
//                         [0.3, 11, 0, 0],
//                         [0.3, 12, 18, 20],
//                         [0.3, 12, 18, 22],
//                         [0.3, 12, 18, 19],
//                         [0.3, 12, 17, 20],
//                         [0.3, 12, 17, 22],
//                         [0.3, 12, 17, 19],
//                         [0.3, 13, 0, 20],
//                         [0.3, 13, 0, 22],
//                         [0.3, 13, 0, 19],
//                         [0.3, 14, 0, 20],
//                         [0.3, 14, 0, 19],
//                         [0.3, 14, 0, 22],
//                         [0.3, 15, 0, 19],
//                         [0.3, 15, 0, 20],
//                         [0.3, 15, 0, 22],
//                         [0.3, 0, 0, 0]
//                     ]
//                     let menAnswers = [
//                         //men with beard
//                         'Masz poniżej 18 lat. Aby rozpocząć budowanie historii kredytowej, musisz nieco urosnąć. Jeśli przez pomyłkę wybrałeś zdjęcie, wybierz nowe  i spróbuj ponownie',
//                         'Jesteś poważnym mężczyzną w wieku ' + age + '. I prawdopodobnie jesteś osobą odnoszącą sukcesy! W końcu broda i świeże spojrzenie świadczą o wytrwałości i zdolności do osiągnięcia celu. Jednak w tej chwili brakuje  uśmiechu, ponieważ uśmiech jest bardzo ważny dla pożyczkodawcy',
//                         'Jesteś mężczyzną w wieku ' + age + '. Broda mówi o Twoim doświadczeniu i statusie. Radzimy nie myśleć o negatywnych doświadczeniach, uśmiechać się, bo życie jest piękne!',
//                         'Jesteś mężczyzną w wieku ' + age + '. Broda mówi o twoim doświadczeniu i statusie. Nasza wskazówka: spróbuj zauważyć piękno w detalach',
//                         'Jesteś atrakcyjnym mężczyzną w wieku ' + age + '. Broda mówi o twoim doświadczeniu i statusie. Nie powinieneś się niczego bać, jesteś zdolny do czegoś więcej niż myślisz',
//                         'Przed nami stylowy mężczyzna mający około ' + age + '. Masz sentymentalną stylizacje i jesteś podatny na estetykę. Okulary do czytania na twarzy świadczą o tym, że jesteś bardzo doświadczoną osobą. Przyjemnie jest przebywać z Tobą, ponieważ promieniujesz szczęściem!',
//                         'Jesteś stylowym mężczyzną w wieku około ' + age + '. Masz subtelną naturę i jesteś podatny na estetykę. Przyjemnie jest przebywać z Tobą, ponieważ promieniujesz szczęściem! Twój uśmiech jest twoją bronią',
//                         'Przed nami stylowy mężczyzna w wieku około ' + age + '. Masz subtelną naturę i jesteś podatny na estetykę. Przyjemnie jest przebywać z Tobą, ponieważ promieniujesz szczęściem! ',
//                         'Jesteś atrakcyjnym mężczyzną w wieku ' + age + '. Okulary do czytania na twarzy świadczą o tym, że jesteś bardzo doświadczoną osobą. Ponadto masz skłonność do estetyki. Przyjemnie być blisko Ciebie, ponieważ promieniujesz szczęściem!',
//                         'Bywasz niegrzecznym mężczyzną w wieku ' + age + '. Jednoznacznie znasz się na stylu. Broda mówi o Twoim doświadczeniu, statusie i oczywiście stylu. Jesteś z siebie zadowolony, ponieważ promieniujesz szczęściem! Radzimy nie ukrywać szczęśliwych oczu za okularami',
//                         'Bywasz niegrzecznym mężczyzną w wieku ' + age + '. Jednoznacznie znasz się na stylu. Broda mówi o Twoim doświadczeniu, statusie i oczywiście stylu. Jesteś z siebie zadowolony, ponieważ promieniujesz szczęściem! ',
//                         'Jesteś atrakcyjnym mężczyzną w wieku ' + age + '. Twój spokój i równowaga świadczą o duchowej harmonii, a okulary do czytania, że jesteś bardzo doświadczoną osobą.',
//                         'Przed nami elegancki mężczyzna ow ieku ' + age + '. Jesteś romantyczną i oryginalną osobą. Twoją bronią jest spokój i równowaga. Radzimy nie chować oczu za okularami przeciwsłonecznymi.',
//                         'Przed nami elegancki mężczyzna w wieku ' + age + '. Jesteś romantyczną i oryginalną osobą. Twoja broń to - spokój i równowaga.',
//                         'Jesteś bardzo doświadczonym mężczyzną w wieku ' + age + '. Nie powinieneś się smucić. Wystarczy uśmiechnąć się, a wokół  rozkwitną jasne kolory. Uśmiech sprawia cuda, nawet z wierzycielami.',
//                         'Przed nami romantyk w wieku około ' + age + ' ze stylową brodą. Nie powinieneś się smucić., ponieważ dobry nastrój jest kluczem do sukcesu. Uśmiechnij się',
//                         'Przed nami romantyk w wieku około ' + age + ' ze stylową brodą. Nie powinieneś się smucić., ponieważ dobry nastrój jest kluczem do sukcesu. Uśmiechnij się',
//                         'Jesteś stylowym mężczyzną w wieku ' + age + '. Jesteś romantyczną i oryginalną osobowością i wygląda na to, że jesteś zdumiony. Mamy nadzieję, że była to miła niespodzianka.',
//                         'Jesteś stylowym mężczyzną w wieku ' + age + '. Jesteś romantyczną i oryginalną osobowością i wygląda na to, że jesteś zdumiony. Mamy nadzieję, że była to miła niespodzianka.',
//                         'Jesteś stylowym mężczyzną w wieku ' + age + '. Jesteś romantyczną i oryginalną osobowością i wygląda na to, że jesteś zdumiony. Mamy nadzieję, że była to miła niespodzianka.',
//                         //men without beard
//                         'Jesteś bardzo poważną osobą w wieku około ' + age + '. Warto jednak pamiętać, że roztopić gniew można szczerym uśmiechem! Uśmiechaj się, bo życie jest piękne! Wierzyciele docenią twój uśmiech.',
//                         'Jesteś atrakcyjnym mężczyzną w wieku ' + age + '. Nie musisz myśleć o negatywach. Uśmiechnij się, dodatkowo z uśmiechem wyglądasz młodziej.',
//                         'Jesteś atrakcyjnym mężczyzną w wieku ' + age + '. Nie musisz myśleć o negatywach. Uśmiechnij się, dodatkowo z uśmiechem wyglądasz młodziej.',
//                         'Jesteś atrakcyjnym mężczyzną w wieku ' + age + '. Nie powinieneś się niczego bać, twoją tajną bronią jest twój umysł',
//                         'Jesteś atrakcyjnym mężczyzną w wieku ' + age + '. Okulary do czytania na twarzy świadczą o tym, że jesteś bardzo doświadczoną osobą. Miło być blisko Ciebie, ponieważ promieniujesz szczęściem!',
//                         'Jesteś stylowym mężczyzną w wieku ' + age + '. Uśmiech jest dla ciebie bardzo ważny! Nawet kredytodawcy już to docenili. Z przyjemnością spędza się czas w Twoim towarzystwie. Następnym razem nie chowaj oczu za okulary.',
//                         'Jesteś stylowym mężczyzną w wieku ' + age + '. Uśmiech jest dla ciebie bardzo ważny! Nawet kredytodawcy już to docenili. Z przyjemnością spędza się czas w Twoim towarzystwie',
//                         'Jesteś doświadczoną osobą w wieku około ' + age + '. Okulary na twojej twarzy wskazują, że jesteś wykształconą osobą. Przyjemnie jest przebywać z Tobą - promieniujesz szczęściem!',
//                         'Jesteś stylowym mężczyzną w wieku ' + age + '. Miło jest bywać z Tobą, ponieważ promieniujesz szczęściem! Nasza rada - nie zapominaj o przyjaciołach i nie kryj zadowolonego wyrazu oczu za okularami',
//                         'Jesteś stylowym mężczyzną w wieku ' + age + '. Miło jest bywać z Tobą, ponieważ promieniujesz szczęściem! Nasza rada - nie zapominaj o przyjaciołach ',
//                         'Jesteś atrakcyjnym mężczyzną w wieku ' + age + '. Twój spokój ducha i równowaga wskazują na duchową harmonię, a okulary do czytania na twojej twarzy, że jesteś osobą wykształconą.',
//                         'Przed nami elegancki mężczyzna w wieku ' + age + '. Zawsze masz wszystko pod kontrolą. Twoją bronią jest spokój i równowaga',
//                         'Przed nami elegancki mężczyzna w wieku ' + age + '. Zawsze masz wszystko pod kontrolą. Twoją bronią jest spokój i równowaga',
//                         'Jesteś inteligentnym i dobrze wykształconym człowiekiem w wieku AGE. Niewątpliwie jesteś właścicielem swojego losu. Po prostu musisz się uśmiechać, a dookoła będą jaśniejsze barwy.',
//                         'Jesteś atrakcyjnym mężczyzną w wieku ' + age + '. Nie lubisz się smucić. Być może dla dobrego nastroju i uśmiechu na Twojej twarzy nie ma wystarcza udanej podróży. Dobry nastrój jest kluczem do sukcesu. Uśmiechnij się',
//                         'Jesteś atrakcyjnym mężczyzną w wieku ' + age + '. Nie lubisz się smucić. Być może dla dobrego nastroju i uśmiechu na Twojej twarzy nie ma wystarcza udanej podróży. Dobry nastrój jest kluczem do sukcesu. Uśmiechnij się',
//                         'Jesteś stylowym mężczyzną w wieku ' + age + '. Zgodnie z Twoim zdjęciem możemy powiedzieć, że jesteś nieco zaskoczony. Mamy nadzieję, że była to miła niespodzianka.',
//                         'Jesteś stylowym mężczyzną w wieku ' + age + '. Zgodnie z Twoim zdjęciem możemy powiedzieć, że jesteś nieco zaskoczony. Mamy nadzieję, że była to miła niespodzianka.',
//                         'Jesteś stylowym mężczyzną w wieku ' + age + '. Zgodnie z Twoim zdjęciem możemy powiedzieć, że jesteś nieco zaskoczony. Mamy nadzieję, że była to miła niespodzianka.',
//                         'Masz ponad 70 lat. Z ciepłem i szacunkiem odnosimy się do Twojego dojrzałego wieku.'
//                     ]
//                     let womanAnswer = [
//                         'Słoneczko, nie masz jeszcze 18 lat. Aby rozpocząć budowanie historii kredytowej, musisz jeszcze trochę poczekać. Jeśli przez pomyłkę wybrałaś zdjęcie, wybierz nowe zdjęcie i spróbuj ponownie',
//                         'Jesteś czarującą dziewczyną mającą około ' + age + ' lat. W pracy jesteś prawdziwym rekinem biznesu. Ale nie zapominaj, uśmiech – to Twoja „tajemnicza” zbroja.',
//                         'Jesteś czarującą dziewczyną mającą około ' + age + ' lat. Nie warto myśleć negatywnie. Uśmiechnij się życie jest piękne.',
//                         'Jesteś czarującą dziewczyną mającą około ' + age + ' lat. Nasza rada – spróbuj zobaczyć piękno w drobnostkach.',
//                         'Jesteś czarującą dziewczyną w wieku ' + age + '. Nie powinnaś niczego się bać. Uśmiechaj się częściej, pożyczkodawcy to lubią.',
//                         'Jesteś czarującą dziewczyną mającą około ' + age + ' lat. Śledzisz trendy modowe, i posiadasz dobry gust. Miło jest przebywać w Twoim towarzystwie ponieważ promieniujesz szczęściem. ',
//                         'Jesteś bardzo stylową kobietą w wieku ' + age + '. Promieniujesz szczęściem i radością. Przed Tobą wiele przyjemnych momentów.',
//                         'Jesteś bardzo stylową kobietą w wieku ' + age + '. Promieniujesz szczęściem i radością. Przed Tobą wiele przyjemnych momentów.',
//                         'Jesteś czarującą dziewczyną w wieku ' + age + '. Spojrzeniem roztapiasz serca, i zawsze z pewnością idziesz do przodu.',
//                         'Jesteś bardzo stylową kobietą mającą około ' + age + ' lat. Miło jest przebywać w Twoim towarzystwie ponieważ promieniujesz szczęściem. Nasza rada – nie zapominaj o przyjaciołach.',
//                         'Jesteś bardzo stylową kobietą mającą około ' + age + ' lat. Miło jest przebywać w Twoim towarzystwie ponieważ promieniujesz szczęściem. Nasza rada – nie zapominaj o przyjaciołach.',
//                         'Jesteś czarującą dziewczyną mającą około ' + age + ' lat. Twój spokój i równowaga świadczą o pełnej harmonii. Sądzimy, iż w najbliższym czasie otrzymasz to co chcesz.',
//                         'Jesteś pełna stylu dziewczyną w wieku ' + age + '. Zawsze masz wszystko pod kontrolą. Twoja broń to Twoje – zabójcze spojrzenie.',
//                         'Jesteś pełna stylu dziewczyną w wieku ' + age + '. Zawsze masz wszystko pod kontrolą. Twoja broń to Twoje – zabójcze spojrzenie.',
//                         'Jesteś czarującą dziewczyną mającą około ' + age + ' lat. Jesteś właścicielką swojej doli. Po prostu musisz się uśmiechać, a dookoła świat będzie w jaśniejszych barwach.',
//                         'Jesteś atrakcyjną dziewczyną mającą około ' + age + ' lat. Czeka na Ciebie niezapomniana wycieczka w miłym towarzystwie. Uzbrój się w cierpliwość.',
//                         'Jesteś atrakcyjną dziewczyną mającą około ' + age + ' lat. Czeka na Ciebie niezapomniana wycieczka w miłym towarzystwie. Uzbrój się w cierpliwość.',
//                         'Jesteś dziewczyną w wieku około ' + age + ' lat. Gwiazdy mówią, że  dziś będziesz mieć szczęście. Sprawdź swoją historię w BIK i uzyskaj dzisiaj pożyczkę',
//                         'Jesteś dziewczyną w wieku około ' + age + ' lat. Gwiazdy mówią, że  dziś będziesz mieć szczęście. Sprawdź swoją historię w BIK i uzyskaj dzisiaj pożyczkę',
//                         'Jesteś dziewczyną w wieku około ' + age + ' lat. Gwiazdy mówią, że  dziś będziesz mieć szczęście. Sprawdź swoją historię w BIK i uzyskaj dzisiaj pożyczkę',

//                         'Przed nami jest wspaniała kobieta około ' + age + ' lat. Lubisz mieć wszystko pod kontrolą, ale nie zapominaj, że uśmiech na twojej twarzy to już 80% sukcesu.',
//                         'Jesteś wspaniałą kobietą w wieku około ' + age + ' lat. Nie ma znaczenia, co się dzieje, jeśli jesteś blisko. Po prostu uśmiechnij się do innych, a dostaniesz dwa razy więcej przyjemnych chwil od życia.',
//                         'Jesteś atrakcyjną kobietą w wieku ' + age + '. Pamiętaj, że Twoja mądrość i uroda nie pozostawi nikogo obojętnym. Nasza wskazówka – to dostrzegać piękno w szczegółach.',
//                         'Jesteś czarującą dziewczyną w wieku ' + age + '. Nie powinieneś się niczego bać. Uśmiechaj się częściej, pożyczkodawcy to lubią :)',
//                         'Jesteś czarującą kobietą w wieku ' + age + '. Podążasz za modą i masz dobry gust. Miło jest przebywać w Twoim towarzystwie, ponieważ promieniujesz szczęściem!',
//                         'Jesteś czarującą kobietą w wieku ' + age + '. Promieniujesz radością i szczęściem. Poczucie stylu jest twoją przewagą. Czeka na Ciebie wiele przyjemnych chwil.',
//                         'Jesteś czarującą kobietą w wieku ' + age + '. Promieniujesz radością i szczęściem. Poczucie stylu jest twoją przewagą. Czeka na Ciebie wiele przyjemnych chwil.',
//                         'Jesteś czarującą kobietą w wieku około ' + age + ' lat. Doświadczenie i mądrość są Twoimi zaletami. Spojrzeniem roztapiasz serca, ale zawsze staraj się robić krok naprzód.',
//                         'Jesteś czarującą kobietą w wieku około ' + age + ' lat. Miło jest przebywać z Tobą, ponieważ promieniujesz szczęściem! Nasza rada - odpoczynek będzie dla Ciebie korzystny.',
//                         'Jesteś czarującą kobietą w wieku około ' + age + ' lat. Miło jest przebywać z Tobą, ponieważ promieniujesz szczęściem! Nasza rada - odpoczynek będzie dla Ciebie korzystny.',
//                         'Jesteś czarującą kobietą w wieku około ' + age + ' lat. Twoja równowaga i spokój świadczą o duchowej harmonii. Myślę, że w niedalekiej przyszłości dostaniesz to co pożądasz',
//                         'Jesteś czarującą kobietą w wieku około ' + age + ' lat. Twoja równowaga i spokój świadczą o duchowej harmonii. Myślę, że w niedalekiej przyszłości dostaniesz to co pożądasz',
//                         'Jesteś czarującą kobietą w wieku ' + age + '. Kontrolujesz sytuację. Twoja broń to Twoje zabójcze spojrzenie, nie chowaj się za okularami przeciwsłonecznymi.',
//                         'Jesteś czarującą kobietą w wieku ' + age + '. Jesteś właścicielem swojej doli. Po prostu powinnaś więcej się uśmiechać, a dookoła świat będzie w jaśniejszych barwach.',
//                         'Jesteś czarującą kobietą w wieku ' + age + '. Czeka na Ciebie niezapomniana wyprawa w przyjemnym towarzystwie. Uzbrój się w cierpliwość',
//                         'Jesteś czarującą kobietą w wieku ' + age + '. Czeka na Ciebie niezapomniana wyprawa w przyjemnym towarzystwie. Uzbrój się w cierpliwość',
//                         'Jesteś czarującą kobietą w wieku ' + age + '. Gwiazdy mówią, że będziesz mieć dziś szczęście. Sprawdź swoją historię w BIK i uzyskaj dzisiaj pożyczkę',
//                         'Jesteś czarującą kobietą w wieku ' + age + '. Gwiazdy mówią, że będziesz mieć dziś szczęście. Sprawdź swoją historię w BIK i uzyskaj dzisiaj pożyczkę',
//                         'Jesteś czarującą kobietą w wieku ' + age + '. Gwiazdy mówią, że będziesz mieć dziś szczęście. Sprawdź swoją historię w BIK i uzyskaj dzisiaj pożyczkę',
//                         'Z dużym szacunkiem odnosimy się do Twojego dojrzałego wieku.'
//                     ]



//                     if (gender === 'male') {
//                         age < 18 ? age = 1 : age >= 18 && age < 70 ? age = 2 : age = 3;
//                         facialHair.beard < 0.9 ? facialHair = 5 : facialHair = 6;
//                         actualMatrix = matrixMen;
//                         answer = menAnswers;
//                         respArray = [age, facialHair, priorityEmotion, smile, glasses]
//                     }
//                     else {
//                         age < 18 ? age = 1 : age >= 18 && age < 35 ? age = 0.2 : age >= 35 && age < 70 ? age = 0.3 : age = 3;
//                         actualMatrix = matrixWoman;
//                         answer = womanAnswer;
//                         respArray = [age, priorityEmotion, smile, glasses]
//                     }

//                     // let respArray = [age, facialHair, priorityEmotion, smile, glasses]

//                     for (let i = 0; i < actualMatrix.length; i++) {
//                         for (let j = 0; j <= respArray.length; j++) {

//                             if (actualMatrix[i][j] === 0) {
//                                 respArray[j] = 0;
//                             }
//                         }
//                         if (actualMatrix[i].toString() === respArray.toString()) {
//                             $('#user-info').text(answer[i])
//                             break
//                         }
//                         else {
//                             gender === 'male' ? respArray = [age, facialHair, priorityEmotion, smile, glasses] : respArray = [age, priorityEmotion, smile, glasses]
//                         }
//                     }


//                     let happiness = emotion.happiness;

//                     switch (true) {
//                         case happiness <= 0.4:
//                             $('#happiness').text('Między nami mówiąc nie jesteś pożyczkobiorcą, ale marzeniem każdego pożyczkodawcy. Twoje porównanie do zaufanego użytkownika wynosi 40%. Jednak możemy się mylić.')
//                             // $('#conclusion').text(`Zarejestruj się i sprawdź swoją ocenę w BIK (jeden bezpłatny wniosek).`)
//                             happiness = 40
//                             break;
//                         case 0.4 < happiness && happiness <= 0.6:
//                             $('#happiness').text('Twoje szanse są wyższe niż średnie, co oznacza, że w 60% spełniasz warunki zaufanego pożyczkobiorcy. Możesz teraz zwiększyć swoje szanse!');
//                             // $('#conclusion').text('Zarejestruj się, sprawdź swoją ocenę w BIK (jeden bezpłatny wniosek) i uzyskaj rekomendacje  pożyczek, aby poprawić swoją zdolność kredytową już dziś!')
//                             happiness = 60
//                             break;
//                         case 0.6 < happiness && happiness < 0.8:
//                             $('#happiness').text('Gratulacje! Jesteś prawie u celu, w 80% spełniasz warunki zaufanego pożyczkobiorcy.')
//                             // $('#conclusion').text('Zarejestruj się, sprawdź swoją ocenę w BIK (jeden bezpłatny wniosek) i uzyskaj rekomendacje  pożyczek, aby poprawić swoją zdolność kredytową już dziś!')
//                             happiness = 80
//                             break;
//                         case happiness >= 0.8:
//                             $('#happiness').text('Hurra! Jesteś w 100% wiarygodnym pożyczkobiorcą. Kredytodawcy są bardzo zainteresowani takimi klientami jak Ty! Partnerzy już przygotowali oferty specjalnie dla Ciebie.')
//                             // $('#conclusion').text('Zarejestruj się, sprawdź swoją ocenę w BIK (jeden bezpłatny wniosek) i ciesz się wszystkimi korzyściami już teraz.')
//                             happiness = 100
//                             break;
//                     }

//                     $('#percent').text(happiness + '%')
//                     $('#ranking').css('display', 'block')
//                     $('#used-button').addClass('secondary-button')
//                 }

//                 else {
//                     $('.personal-info').fadeOut()
//                     $('#happiness').fadeOut()
//                     $('#conclusion').fadeOut()
//                     $('.ocena').fadeOut()
//                     if (data && data.length > 1) {
//                         $('#user-info').text('Przepraszamy, ale na fotografii wskazane bardziej jednego człowieka. Załadujcie, proszę, inną fotografię i powtórzcie próbę.')
//                     }
//                     else {
//                         $('#user-info').text('Przepraszamy, ale Wasza fotografia nie została rozpoznana. Załadujcie, proszę, inną fotografię i powtórzcie próbę.')
//                     }
//                 }

//             })

//             .fail(function (jqXHR, textStatus, errorThrown) {
//                 // Display error message.
//                 var errorString = (errorThrown === "") ?
//                     "Error. " : errorThrown + " (" + jqXHR.status + "): ";
//                 errorString += (jqXHR.responseText === "") ?
//                     "" : (jQuery.parseJSON(jqXHR.responseText).message) ?
//                         jQuery.parseJSON(jqXHR.responseText).message :
//                         jQuery.parseJSON(jqXHR.responseText).error.message;
//                 alert(errorString);
//             });
//         // } else{
//         // 	getPhotoInfo()
//         // }
//     }

//     $scope.makeblob = function (dataURL) {
//         let BASE64_MARKER = ';base64,';
//         if (dataURL.indexOf(BASE64_MARKER) == -1) {
//             let parts = dataURL.split(',');
//             let contentType = parts[0].split(':')[1];
//             let raw = decodeURIComponent(parts[1]);
//             return new Blob([raw], { type: contentType });
//         }
//         let parts = dataURL.split(BASE64_MARKER);
//         let contentType = parts[0].split(':')[1];
//         let raw = window.atob(parts[1]);
//         let rawLength = raw.length;
//         let uInt8Array = new Uint8Array(rawLength);
//         for (let i = 0; i < rawLength; ++i) {
//             uInt8Array[i] = raw.charCodeAt(i);
//         }
//         return new Blob([uInt8Array], { type: contentType });
//     }

//     $scope.showButton = () => {
//         $(".get-report-btn").css("display", "block")
//         // $(".get-report-btn").slideDown("slow");
//         $(".upload-photo").addClass("white")
//     };


//     $scope.shareId = '';

//     $scope.generateId = () => {
//         return 'xxxxxxxx4xxx'.replace(/[xy]/g, function (c) {
//             var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
//             return v.toString(36);
//         });
//     }

//     $scope.shareError = () => {
//         $scope.switchLoader(false, '.loader-fullScreen');
//         $scope.showAlert('error', 'Przepraszamy, wystąpił pewien problem techniczny. Spróbuj ponownie później');
//     }

//     $scope.setShareParams = () => {
//         $scope.switchLoader(true, '.loader-fullScreen');
//         $scope.shareId = $scope.generateId();
//         let description, title, successFunc
//         if ($scope.isPhotoAcceptable) {
//             description = $('#user-info').text();
//             title = "O tobie";
//             successFunc = $scope.sendShareImg;
//         } else {
//             description = `Sprawdź, co możesz dowiedzieć się o sobie, jako pożyczkobiorcy, na podstawie swojego zdjęcia. Prześlij swoje zdjęcie i od razu uzyskaj swoja ocenę kredytową`;
//             title = "Oceń swoją możliwość uzyskania pożyczki na podstawie zdjęcia";
//             successFunc = $scope.scrapeShareInfo;
//         }
//         $scope.sendShareParams(description, title, successFunc);
//     }

//     $scope.sendShareParams = (description, title, successFunc) => {
//         $.ajax({
//             type: 'POST',
//             url: `/api/front/share/share/save-description`,
//             data: {
//                 description: description,
//                 title: title,
//                 id: $scope.shareId
//             },
//             success: successFunc,
//             error: $scope.shareError
//         });
//     }

//     $scope.sendShareImg = () => {
//         $http({
//             method: 'POST',
//             url: `/api/front/share/share/save-photo/?id=${$scope.shareId}`,
//             headers: { 'Content-Type': undefined },
//             transformRequest: function (data) {
//                 var formData = new FormData();
//                 formData.append("file", data.files);
//                 return formData;
//             },
//             data: { files: $scope.shareImg }
//         })
//             .then(function successCallback() { $scope.scrapeShareInfo() },
//                 function errorCallback() {
//                     $scope.shareError()
//                 });
//     }

//     $scope.scrapeShareInfo = () => {
//         var url = `https://racoongo.com/share/?id=${$scope.shareId}`;
//         $.ajax({
//             type: 'POST',
//             url: `https://graph.facebook.com/?id=${url}&scrape=true&access_token=171563313528859|ysp95PV0LCTJKoG0w0M65F_ULzU`,
//             success: $scope.shareFacebook,
//             error: $scope.shareError
//         });
//     }

//     $scope.shareFacebook = () => {
//         setTimeout(function () {
//             let url = encodeURIComponent(`https://racoongo.com/share/?id=${$scope.shareId}`)
//             $scope.switchLoader(false, '.loader-fullScreen');
//             let myWin = open(`http://www.facebook.com/sharer.php?u=${url}`, "displayWindow", "width=520,height=300,left=350,top=170,status=no,toolbar=no,menubar=no");
//             $scope.countPhotoActivity(0, 1);
//         }, 4000)
//     }

//     $scope.countPhotoActivity = (scaner, share) => {
//         let reportActivity = {
//             scaner: scaner,
//             share: share
//         }
//         $scope.sendXHR({
//             url: `/api/front/track/track/execute`,
//             data: reportActivity,
//             successFunc: ""
//         });
//     }

//     $(".tip_icon").click(function () {
//         $(".reportPhoto_tip").slideToggle();
//     })
//     $(".reportPhoto_tip").click(() => {
//         $(".reportPhoto_tip").slideUp();
//     })

// }])



// WEBPACK FOOTER //
// src/js/controllers/bikfish/bikPhotoCtrl.js